import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

// import { VUEX_DEFAULT_CONFIG } from '@/config'
import modules from './modules'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['pageTag', 'user'],
  // filter: (mutation) => mutation.type === 'addNavItem'
})

Vue.use(Vuex)
const storeInstance = new Vuex.Store({
  strict: true,
  // ...VUEX_DEFAULT_CONFIG,
  ...modules,
  getters,
  plugins: [vuexLocal.plugin]
})

export default storeInstance
